import React from 'react';
import { useIsFetching } from 'react-query';
import './globalloader.css';
import { Loading } from '@dsi/react-eds';

const GlobalLoader = () => {
  const isFetching = useIsFetching();
  const isLoading = isFetching > 0;

   return isLoading ? (
     <div className="loader-overlay">
          <Loading size="medium" />
        </div>
  ) : null;
};

export default GlobalLoader;
